exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timeSlot-Header {\n    -webkit-transform: rotate(270deg);\n            transform: rotate(270deg);\n    width: 45px;\n    height: 25px;\n    margin-left: -6px;\n    padding-top: 6px;\n}\n\ntable {\n    border-spacing: 0\n}\n\n.react-confirm-alert-button-group {\n    justify-content: center !important;\n}\n\n.react-confirm-alert-body{\n    text-align: center !important;\n}", ""]);

// exports
